import { render, staticRenderFns } from "./ClassificationUpload.vue?vue&type=template&id=c3a27a18&"
import script from "./ClassificationUpload.vue?vue&type=script&lang=ts&"
export * from "./ClassificationUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports